// extracted by mini-css-extract-plugin
export default {"root":"ModalContent_root__IVxxl"};